/**
 * User service related error code enumeration
 * Includes various error identifiers and descriptions that may occur during user operations
 */
export enum ErrorCode {
  // Invalid clientId
  InvalidClientId = 'USS-0201',

  // Invalid username, need to check if the username format is correct
  InvalidUsername = 'USS-0100',

  // Username or password does not exist
  UsernameNotExists = 'USS-0103',

  // Username already exists
  UsernameExists = 'USS-0104',

  // Missing parameters
  MissingParameters = 'USS-0135',

  // Request locked (e.g., frequent requests)
  RequestLocked = 'USS-0151',

  // Session expired
  SessionExpired = 'USS-0302',

  // Invalid username format
  InvalidUsernameFormat = 'USS-0101',

  // User account is frozen and cannot be recovered
  UserFrozen = 'USS-0111',

  // User account has been disabled
  UserDisabled = 'USS-0112',

  // Google recaptcha validation failed
  GoogleRecaptchaFailed = 'USS-0142',

  // Invalid verification code
  InvalidVerificationCode = 'USS-0140',

  // Login locked
  LoginLocked = 'USS-0150',

  // Invalid password format
  InvalidPasswordFormat = 'USS-0170',

  // Insufficient permissions
  InsufficientPermissions = 'USS-0403',

  // passkey exceptions
  PasskeyException = 'USS-9000',

  // User cancelled biometric operation
  UserCancelledFido = 'USS-9001',

  // Passkey/WebAuthn requires HTTPS context
  PasskeyHttpsRequired = 'USS-9002',

  // fido creation failed
  FidoCreateFailed = 'USS-9005',

  // fido authentication failed
  FidoAuthFailed = 'USS-9006',

  // This account is not registered for biometric authentication
  FidoNotRegistered = 'USS-9009',

  // Multiple requests initiated simultaneously
  TroubleShooting = 'USS-0152',

  // Unable to access or read your biometric data
  FidoDataAccessError = 'USS-9007',

  // Third-party login timeout
  SocialLoginTimeout = 'USS-0124',

  // Third-party accessToken error
  SocialLoginInvalidToken = 'USS-0220',

  // Third-party email not obtained
  SocialLoginNoEmail = 'USS-0211',

  /** 请求超时 */
  RequestTimeout = 'USS-0408',

  NetWorkError = 'USS-0500',
}
